export type RecurringUnit = 'day' | 'week' | 'month' | 'year';

export const RECURRING_UNITS: readonly RecurringUnit[] = [
  'day',
  'week',
  'month',
  'year',
];

export const MAX_RECURRING_EVERY = 99;

/** Repeats every `every` units, `every` an integer from 1 to MAX_RECURRING_EVERY. */
export interface RecurringCadence {
  every: number;
  unit: RecurringUnit;
}

/** Active and paused rules count; ended ones do not. */
export const MAX_RECURRING_RULES_PER_GROUP = 50;

/** Missed occurrences older than this are skipped, never back-filled. */
export const RECURRING_CATCH_UP_DAYS = 7;

export const RECURRING_ERROR_KEYS = {
  proRequired: 'errors:recurring.proRequired',
  groupCurrencyOnly: 'errors:recurring.groupCurrencyOnly',
  plainExpenseOnly: 'errors:recurring.plainExpenseOnly',
  tooMany: 'errors:recurring.tooMany',
  notAllowed: 'errors:recurring.notAllowed',
  memberLeft: 'errors:recurring.memberLeft',
  ended: 'errors:recurring.ended',
  notFound: 'errors:recurring.notFound',
} as const;

/** The permanent offline-sync failure of a queued create whose `repeat` the server refused for Pro. */
export const SYNC_REPEAT_PRO_REQUIRED_ERROR =
  'common:offline.repeatProRequired';
